/* Submit the existing Rise form: the native component owns cart, errors and variants. */
function pvSubmitNativePurchase(target) {
  const form = target?.querySelector('product-form form');
  const submit = form?.querySelector('[name="add"]');
  if (!form || !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
  const quantity = target.querySelector('.quantity__input');
  if (quantity && !quantity.checkValidity()) {
    quantity.scrollIntoView({ block: 'center' });
    quantity.reportValidity();
    return;
  }
  form.requestSubmit(submit);
}

if (!customElements.get('pv-purchase-bar')) {
  customElements.define('pv-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      this.target = document.getElementById(this.dataset.target);
      this.button = this.querySelector('[data-pv-add-to-cart]');
      if (!this.target || !this.button) return;
      this.onClick = () => pvSubmitNativePurchase(this.target);
      this.button.addEventListener('click', this.onClick);
      this.sync = () => {
        const price = this.target.querySelector('[id^="price-"] .price');
        const selected = price?.classList.contains('price--on-sale')
          ? price.querySelector('.price__sale .price-item--sale')
          : price?.querySelector('.price__regular .price-item--regular');
        this.querySelector('[data-pv-price]').textContent = selected?.textContent.trim() || '';
        const native = this.target.querySelector('product-form [name="add"]');
        const loading = native?.getAttribute('aria-disabled') === 'true';
        this.button.disabled = !native || native.disabled || loading;
        this.button.textContent = loading ? this.button.dataset.loadingLabel
          : native?.disabled ? native.querySelector('span')?.textContent.trim()
          : this.button.dataset.label || native?.querySelector('span')?.textContent.trim() || '';
        const error = this.target.querySelector('.product-form__error-message-wrapper');
        if (error && !error.hidden && !this.errorVisible) {
          error.setAttribute('tabindex', '-1');
          error.scrollIntoView({ block: 'center' });
          error.focus({ preventScroll: true });
        }
        this.errorVisible = error && !error.hidden;
      };
      this.mutation = new MutationObserver(this.sync);
      this.mutation.observe(this.target, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'hidden'] });
      this.sync();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.hidden = entry.isIntersecting && entry.intersectionRatio >= 0.99;
        }, { threshold: [0, 1] });
        this.observer.observe(this.target.querySelector('product-form [name="add"]') || this.target);
      } else this.hidden = false;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.mutation?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}

if (!window.pvPurchaseClickBound) {
  window.pvPurchaseClickBound = true;
  document.addEventListener('click', event => {
    if (event.target.closest('[data-pv-submit-current]')) {
      pvSubmitNativePurchase(document.querySelector('product-info.pv-purchase, product-info.pv-organic'));
    }
  });
}
